module.exports = __webpack_public_path__ + "static/pinto.6eeddb48.svg";